var map = {
	"./Alliums-Asparagus-individual-icon.png": 7535,
	"./Alliums-Garlic-individual-icon.png": 9057,
	"./Alliums-Icon.png": 6313,
	"./Alliums-Onion-individual-icon.png": 4286,
	"./Alternative-Flour-Icon.png": 5839,
	"./Alternative-Flour-Individual-Icon.png": 3125,
	"./Beans-Peas-Lentils-Icon.png": 410,
	"./Beans_Peas_Lentils-Individual-Icon.png": 8831,
	"./Beans_Peas_Lentils-Peas-individual-Icon.png": 4924,
	"./Beer-Cider-Hard-Seltzer-Beer-individual-icon.png": 3327,
	"./Beer-Cider-Hard-Seltzer-Icon.png": 944,
	"./Berries-Blackberry-individual-icon.png": 8866,
	"./Berries-Blueberries-individual-icon-thicker-line.png": 9563,
	"./Berries-Icon.png": 2160,
	"./Berries-Strawberry-individual-icon.png": 510,
	"./Butter-Margarine-Coconut-Oil-Icon.png": 2855,
	"./Butter-Margarine-Coconut-Oil-Individual-icon.png": 2046,
	"./Caffeinated-Beverages-Category-Icon-Option-2.png": 1887,
	"./Caffeinated-Beverages-Coffee-tea-Cup-individual-icon.png": 9957,
	"./Caffeinated-Beverages-Espresso-individual-icon.png": 3074,
	"./Caffeinated-Beverages-Icon-Option-2.png": 1557,
	"./Caffeinated-Beverages-Icon.png": 869,
	"./Cereal-Granola-Cereal-individual-icon.png": 3747,
	"./Cereal-Granola-Granola-bar-individual-icon.png": 2548,
	"./Cereal-Granola-Granola-individual-icon.png": 2598,
	"./Cereal-Granola-Icon.png": 5147,
	"./Citrus-Fruit-Icon.png": 6257,
	"./Citrus-Fruit-Lemon-individual-icon.png": 2536,
	"./Condiments-BBQ-Sauce-individual-icon.png": 3058,
	"./Condiments-Balsamic-Vinegar-individual-icon.png": 9948,
	"./Condiments-Icon.png": 1575,
	"./Condiments-Ketchup-individual-icon.png": 7578,
	"./Condiments-Mustard-individual.png": 2464,
	"./Cookin-Oils-except-olive-and-canola-category-option-1.png": 9559,
	"./Cooking-Oils-Icon.png": 375,
	"./Cruciferous-Vegetables-Icon.png": 9793,
	"./Distilled-Liquor-Icon.png": 8677,
	"./Distilled-Liquor-Mixed-Drink-individual-icon.png": 5547,
	"./Distilled-Liquor-Shots-individual-icon.png": 2559,
	"./Fried-Fast-Food-Doughnut-individual-icon.png": 6492,
	"./Fried-Fast-Food-Fries-individual-icon.png": 7380,
	"./Fried-Fast-Food-Icon-Option-2.png": 7513,
	"./Fried-Fast-Food-Icon.png": 272,
	"./Fried-Fast-Food-Pizza-individual-icon.png": 2354,
	"./Frozen-Food-Icon.png": 6330,
	"./GF-Grains-Icon.png": 8583,
	"./GF-Grains-Rice-individual-icon.png": 9478,
	"./Hard-Cheese-Icon.png": 2396,
	"./Hard-Cheese-Individual-Icon.png": 3881,
	"./Herbal-Tea-Icon.png": 106,
	"./Jams-Jellies-Icon.png": 1168,
	"./Jams-Jellies-Individual-Icon-Option-2.png": 4144,
	"./Juice-Sports-Drinks-Coconut-Water-individual-icon.png": 8896,
	"./Juice-Sports-Drinks-Icon.png": 8347,
	"./Juice-Sports-Drinks-Sport-Drink-individual-icon.png": 183,
	"./Leafy-Greens-Category-Icon-Option-1.png": 829,
	"./Leafy-Greens-Icon.png": 9562,
	"./Leafy-Greens-Lettuce-individual-icon.png": 6838,
	"./Leafy-Greens-Spinach-Category-or-Individual-icon.png": 873,
	"./Leafy-Greens-or-Kale.png": 57,
	"./Melon-Icon.png": 285,
	"./Milk-Cream-Category-Option-1.png": 4521,
	"./Milk-Cream-Category-Option-2.png": 3184,
	"./Milk-Cream-Cream-individual-icon.png": 5160,
	"./Milk-Cream-Glass-of-Milk-individual-icon.png": 2089,
	"./Milk-Cream-Ice-Cream-individual-icon.png": 9358,
	"./Milk-Cream-Option-1.png": 1134,
	"./Milk-Cream-Option-2.png": 110,
	"./Mushrooms-Icon-Option-1.png": 1560,
	"./Mushrooms-Icon-Option-2.png": 800,
	"./Nightshades-Eggplant-individual-icon.png": 2150,
	"./Nightshades-Icon.png": 2125,
	"./Nightshades-Pepper-individual-icon.png": 6131,
	"./Nightshades-Tomatoes-Category-Individual-Icon.png": 8190,
	"./Nut-Butters-Icon.png": 4346,
	"./Nuts-Cashew-individual-icon.png": 948,
	"./Olive-Canola-Oil-Icon.png": 9270,
	"./Olive-Oil-Category-Individual-Icon.png": 382,
	"./Packaged-Snacks-Icon.png": 3778,
	"./Pitted-Fruit-Cherries-individual-icon.png": 5158,
	"./Pitted-Fruit-Icon-Option-1.png": 5254,
	"./Pitted-Fruit-Icon-Option-2.png": 8041,
	"./Pitted-Fruit-Peach-individual-icon.png": 4326,
	"./Plant-Based-Milks-Icon.png": 4745,
	"./Pomes-Apple-individual-icon.png": 1452,
	"./Pomes-Icon.png": 386,
	"./Pomes-Pear-individual-icon.png": 8226,
	"./Processed-Meat-Hot-Dogs-individual-icon.png": 8083,
	"./Processed-Meat-Hot-dog-individual-icon.png": 4525,
	"./Processed-Meat-Icon.png": 389,
	"./Processed-Meat-Sausage-(individual-icon).png": 2370,
	"./Processed-Meat-Sausages-category-or-individual-icon.png": 2302,
	"./Pumpkin-Squash-Icon.png": 6491,
	"./Pumpkin_Squash-Pumpkin-individual-icon.png": 356,
	"./Pumpkin_Squash-Squash-individual-icon.png": 137,
	"./Pumpkin_Squash-Zucchini-individual-icon.png": 3221,
	"./Red-Meat-Bacon-individual-icon.png": 7293,
	"./Red-Meat-Icon-Option-1.png": 1142,
	"./Red-Meat-Icon-Option-2.png": 1473,
	"./Red-Meat-Steak-individual-icon.png": 7397,
	"./Root-Vegetable-Celery-individual-icon.png": 5083,
	"./Root-Vegetables-Artichoke-individual-icon.png": 7361,
	"./Root-Vegetables-Beet-Individual-Icon.png": 8632,
	"./Root-Vegetables-Icon.png": 1159,
	"./Seeds-Icon.png": 3272,
	"./Seeds-Tablespoon-of-seeds-individual-icon.png": 2715,
	"./Soda-Energy-Drink-Individual-Icon-Option-3.png": 4515,
	"./Soda-Energy-Drinks-Icon.png": 7577,
	"./Soda-Energy-Drinks-Individual-Icon-Option-1.png": 8870,
	"./Soda-Energy-Drinks-Individual-Icon-Option-2.png": 3490,
	"./Soft-Cheese-Cottage-Cheese-individual-icon.png": 3157,
	"./Soft-Cheese-Icon.png": 2446,
	"./Soy-Products-Category-Individual-Icon.png": 5292,
	"./Soy-Products-Icon.png": 9447,
	"./Soy-Products-Soy-Bean-individual-icon.png": 9914,
	"./Soy-Products-Tempeh-individual-icon.png": 7491,
	"./Spicy-Food-Fire-individual-icon.png": 3951,
	"./Spicy-Food-Hot-Category-Icon.png": 8069,
	"./Spicy-Food-Icon.png": 3553,
	"./Spicy-Food-Medium-Category-Icon.png": 1967,
	"./Spicy-Food-Mild-Category-Icon.png": 4310,
	"./Starchy-Vegetables-Corn-individual-icon.png": 6534,
	"./Starchy-Vegetables-Icon.png": 3862,
	"./Starchy-Vegetables-Potato-individual-icon.png": 8527,
	"./Sugar-Free-Gum-Icon.png": 4735,
	"./Sugar-Free-Gum-Individual-Icon.png": 8614,
	"./Sweeteners-Honey-individual-icon.png": 6779,
	"./Sweeteners-Icon.png": 1236,
	"./Sweeteners-Sugar-Packet-individual-icon.png": 2821,
	"./Sweeteners-Sugar-individual-Icon.png": 3872,
	"./Sweets-Candy-individual-icon.png": 7114,
	"./Sweets-Chocolate-individual-icon.png": 5518,
	"./Sweets-Icon-Option-1.png": 7451,
	"./Sweets-Icon-Option-2.png": 879,
	"./Sweets-Pastry-individual-icon.png": 4662,
	"./Treenuts-Almonds-individual-icon.png": 6306,
	"./Treenuts-Icon.png": 1365,
	"./Treenuts-Pistachios-individual-icon.png": 8526,
	"./Wheat-Products-Bread-individual-icon.png": 7927,
	"./Wheat-Products-Flour-individual-icon.png": 739,
	"./Wheat-Products-Icon.png": 545,
	"./Wheat-Products-Pasta-Individual-Icon.png": 6081,
	"./Wine-Icon.png": 9251,
	"./Wine-Individual-Icon.png": 1437,
	"./dried-fruit.png": 7457,
	"./yogurt.png": 7500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1226;